import { ISanityLocaleBlockContent, ISanityTextNode } from '@rbi-ctg/menu';
import { IContentOption, IImage } from 'generated/sanity-graphql';

// TODO: It would be ideal to refactor this to use generated types instead of menu.d.ts
// - IImage
// - ILocaleBlockContent
// - ILocaleString
export interface IContentOptionsProperties {
  description?: ISanityLocaleBlockContent;
  image?: IImage;
  name?: ISanityTextNode;
}

export interface IMenuObjectWithContentOptions extends IContentOptionsProperties {
  contentOptions?: IContentOption[] | null;
}

export type GetVariantContentOptionsFn = (
  menuObject: IMenuObjectWithContentOptions
) => IContentOptionsProperties;
